module.exports = __webpack_public_path__ + "newsdefault3.jpg?73d0098902c942fe890a4a1cf6340f60";